export default __webpack_public_path__ + "static/media/nextStepsBGMobile.6a48c09d.webp";